import { sanitizeAnalyticsEventPropertyValue } from "./sanitizeAnalyticsUrl";

export default function sanitizeAnalyticsEventProperties(eventProperties) {
  if (!eventProperties || typeof eventProperties !== "object") {
    return eventProperties;
  }

  let changed = false;
  const nextProperties = { ...eventProperties };

  for (const [propertyKey, value] of Object.entries(nextProperties)) {
    const sanitizedValue = sanitizeAnalyticsEventPropertyValue(value);

    if (sanitizedValue !== value) {
      nextProperties[propertyKey] = sanitizedValue;
      changed = true;
    }
  }

  return changed ? nextProperties : eventProperties;
}
